import { gql, useQuery } from "@apollo/client"
import { enablePreview, client } from "../../graphql/contentful/client"
import { ArticleModel } from "../../components/contentful/models"

const createQuery = (searchTerm: string) => {
  let whereClause = ""
  if (searchTerm !== "") {
    const searchFields = ["title_contains", "description_contains", "tags_contains_some"]
      .flatMap((filter) => [searchTerm, searchTerm.toLowerCase()].map((searchValue) => `{${filter}: "${searchValue}"}`))
      .join(",\n")
    whereClause = `, where: {
    OR: [
      ${searchFields}
    ],
    }
    `
  }
  return gql(`
    query getContentfulArticle($skip: Int!, $limit: Int!, $preview: Boolean!) {
      articleCollection(skip: $skip, limit: $limit, preview: $preview ${whereClause}) {
        total
        items {
          sys {
            id
            firstPublishedAt
            publishedAt
          }
          header {
            url(transform: { format: WEBP, width: 2400, quality: 70 })
          }
          title
          slug
          tags
          description
        }
      }
    }
  `)
}

export interface ArticleCollectionQuery {
  articleCollection: {
    items: ArticleModel<string>[]
    total: number
    skip: number
    limit: number
  }
}

export function useArticleCollection(skip: number, limit: number, searchTerm: string) {
  return useQuery<ArticleCollectionQuery>(createQuery(searchTerm), {
    client: client,
    variables: {
      skip,
      limit,
      preview: enablePreview,
    },
  })
}
